module.exports = __webpack_public_path__ + "img/RMX1971.0f5e0de3.jpg";